import React from 'react';
import StatusCell from './StatusCell';
import TimestampCell from 'app/components/data-table/TimestampCell';
import HttpStatusCell from './HttpStatusCell';
import PipelineNameCell from './PipelineNameCell';
import formatEventType from './formatEventType';

const deliveryLogsColumns = [
  {
    name: 'Event Type',
    cell: row => formatEventType(row.eventType),
    sortable: false,
  },
  {
    name: 'Pipeline',
    cell: row => <PipelineNameCell requestPayload={row.requestPayload} />,
    sortable: false,
  },
  {
    name: 'Status',
    cell: row => <StatusCell successAt={row.successAt} />,
    sortable: false,
    width: '120px',
  },
  {
    name: 'HTTP Status',
    cell: row => <HttpStatusCell responseStatus={row.responseStatus} />,
    sortable: false,
    width: '120px',
  },
  {
    name: 'Timestamp',
    cell: row => <TimestampCell timestamp={row.createdAt} />,
    sortable: false,
    width: '200px',
  },
];

export default deliveryLogsColumns;
